import { useState } from 'react';
import { isEqual } from 'es-toolkit';
import type { SetElement } from 'react-use-rect';
import { defaultRect, useStableRect } from './use-stable-rect';

export type BreakpointsType = Record<number, boolean>;

function mapBreakpoints(breakpoints: number[], width?: number) {
  return breakpoints.reduce<BreakpointsType>((breakpointsMap, breakpoint) => {
    breakpointsMap[breakpoint] = width !== undefined && width <= breakpoint;

    return breakpointsMap;
  }, {});
}

export function useBreakpoints(
  ...breakpoints: number[]
): [BreakpointsType, SetElement] {
  const [appliedBreakpoints, setAppliedBreakpoints] = useState(
    mapBreakpoints(breakpoints)
  );

  const [measureRef] = useStableRect(
    defaultRect,
    ({ width }) => {
      const nextBreakpoints = mapBreakpoints(breakpoints, width);

      if (!isEqual(nextBreakpoints, appliedBreakpoints)) {
        setAppliedBreakpoints(nextBreakpoints);
      }
    },
    { resize: true }
  );

  return [appliedBreakpoints, measureRef];
}
